import Unauthenticated from './components/401.vue'
import Unauthorized from './components/403.vue'
import PageNotFound from './components/404.vue'
import InternalServerError from './components/500.vue'

export default [
    {
        name: 'error.401',
        path: '/error-401',
        component: Unauthenticated,
        meta: {
            requiresAuth: true
        }
    },
    {
        name: 'error.403',
        path: '/error-403',
        component: Unauthorized,
        meta: {
            requiresAuth: true
        }
    },
    {
        name: 'error.404',
        path: '/error-404',
        component: PageNotFound,
        meta: {
            requiresAuth: true
        }
    },
    {
        name: 'error.500',
        path: '/error-500',
        component: InternalServerError,
        meta: {
            requiresAuth: true
        }
    }
]



// WEBPACK FOOTER //
// ./src/modules/errors/routes.js